import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import cardbg from "../../../Assets/Images/cards/cardbg.png";
import './style.css'
import { isValidString } from "../../../helper";
import { WEB_URL } from "../../../redux/actions/config";

const PostCarousel = ({ data }) => {

  const RegisterBottons = ({ item }) => {
    if (!item?.register_as_individual && !item?.register_as_team && item?.leaderboard) {
      return (
        <div className="chmpn-select-dropbtn">
          <a className="btn chmpn-pnk-btn" style={{ width: "200px", padding: "8px 10px" }} href={`${WEB_URL}/champions/leaderboard`} target="_blank">Leaderboard</a>
        </div>
      )
    } else if (item?.register_as_individual && item?.register_as_team) {
      return (
        <div className="dropdown  chmpn-select-dropbtn ">
          <button className="btn chmpn-pnk-btn" type="button" id="select-register" data-bs-toggle="dropdown" aria-expanded="false">
            Register now
          </button>
          <ul className="dropdown-menu slct-drop-menu" aria-labelledby="select-register">
            <li>
              <a className="dropdown-item" href={`${WEB_URL}/champions/${item?.event_code}/register/individual`} target="_blank">Register as an individual</a>
            </li>
            <li>
              <a className="dropdown-item" href={`${WEB_URL}/champions/${item?.event_code}/register/team`} target="_blank">Register as a team</a>
            </li>
          </ul>
        </div>
      )
    } else if (item?.register_as_individual) {
      return (
        <div className="chmpn-select-dropbtn">
          <a className="btn chmpn-pnk-btn" style={{ width: "200px", padding: "8px 10px" }} href={`${WEB_URL}/champions/${item?.event_code}/register/individual`} target="_blank">Register as an individual</a>
        </div>
      )
    }
    return null
  }

  const isLive = ((moment().diff(data?.start_date, "seconds") >= 0 || moment().diff(data?.registration_start_date, "seconds") >= 0) && moment().diff(data?.end_date, "seconds") <= 0) ? true : false;
  return (
    <div className="competitions-content-slider col-md-4 px-2 mx-auto my-5">
      <div className="competitions-item">
        <Link><img className="chmpn-slider-img" src={isValidString(data?.image_url) ? data?.image_url : cardbg} /></Link>
        {isLive && <div class="chmpn-live-bdg"><span>live</span></div>}
        <div class="chmpn-slider-content chmpn-register-select-btn">
          {/* <RegisterBottons item={data} /> */}
          <a class="nav-link" href={`${WEB_URL}/champions/${data?.event_code}`}><span>{data?.event_name}</span></a>
          <Link class="nav-link explore-nav" to={data?.is_quiz_only ? "/quiz-program-detail" : `/learning-programs/${data?.event_code}`} state={{ eventCode: data?.event_code }}>Explore more</Link>
        </div>
      </div>
    </div>
  );
};

export default PostCarousel;
